/**
 * Luxury hub browse carousel filters (existing luxury listings).
 * New luxury listings on /list-luxury-piece use the full pre-owned category tree
 * (see PRE_OWNED_ITEM_CATEGORY_DATA + clothing/bags/etc. schemas).
 */
export const LUXURY_PIECE_CATEGORIES = [
  { id: 'bags', name: 'Bags', icon: '👜', apiCategory: 'Bags' },
  { id: 'accessories', name: 'Accessories', icon: '🕶️', apiCategory: 'Accessories' },
  { id: 'vintage', name: 'Vintage Collections', icon: '📦', apiCategory: 'Vintage Collections' },
  { id: 'tableware', name: 'Tableware', icon: '🍽️', apiCategory: 'Tableware' },
  { id: 'jewelry', name: 'Jewelry', icon: '💍', apiCategory: 'Jewelry' },
  { id: 'fashion', name: 'Fashion', icon: '👗', apiCategory: 'Fashion' },
  { id: 'home', name: 'Home Decor', icon: '🏠', apiCategory: 'Home Decor' },
  { id: 'art', name: 'Art & Paintings', icon: '🎨', apiCategory: 'Art & Paintings' },
  { id: 'nails', name: 'Nails', icon: '💅', apiCategory: 'Nails' },
];

export const LUXURY_PIECE_CATEGORY_VALUES = LUXURY_PIECE_CATEGORIES.map((c) => c.apiCategory);
